import { CommonGet, CommonPost } from "../../../utils/CommonFetch";

export default {
    getCardRegenerateDetails,
    getAlGroupsForDropdown,
    getAllOperationEntitiesForDropDown,
    GetCollectionPointsFilter,
    updateStatus
};

async function getCardRegenerateDetails(data) {
    const res = await CommonPost('/api/CardManagement/GetCardsToRegenerate', null, data);
    return res.data;
}

async function getAlGroupsForDropdown() {
    var groupArray = [];

    const response = await CommonGet('/api/Group/GetAllGroups', null)
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }

    return groupArray;
}

async function getAllOperationEntitiesForDropDown(groupID) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetOperationEntityByGroupIDEntityID', 'groupID=' + groupID);
    for (let item of Object.entries(response.data)) {
        operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
     return operationEntityArray;
}

async function GetCollectionPointsFilter(operationEntityID) {
    var collectionPointArray = [];
    var response = await CommonGet('/api/CollectionPoint/GetCollectionPointByOperationEntityId', 'operationEntityID=' + operationEntityID);

    for (let item of Object.entries(response.data)) {
        collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"];
    }
    return collectionPointArray;
}

async function updateStatus(data) {
    const response = await CommonPost('/api/CardManagement/UpdateCardsToRegenerationStatus', null, data);
    return response;
}